import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Bonjour!',
  ProductCode: 'far45',
  Description:
    '<p>Here&#39;s all the online content included with your <strong>French Revision Guide</strong>.&nbsp;</p>\n',
  Credits:
    '<p><em>Contributors: Ben Ffrancon Dowds, Jackie Shaw, Coralie Stewart, Sarah Sweeney </em></p>\n' +
    '\n' +
    '<p><em>Proofreaders: Pat Dunn, Natalie Handley, Natalie Pomier, Véronique Robine</em></p>\n' +
    '\n' +
    '<p><em>AQA material is reproduced by permission of AQA. The worked solutions to questions and commentaries on questions and possible answers in this product have neither been provided by nor approved by AQA.</em></p>\n' +
    '\n' +
    '<p><em>Audio produced by Voice Talent Online.</em></p>\n' +
    '\n' +
    '<p><em>Text, design, layout and original illustrations &copy; Coordination Group Publications Ltd. (CGP) 2024. All rights reserved.</em></p>\n',
};
